import { useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { ShopTypes } from '~/lib/data-contract';
import { Prefetch } from '~/services/types';
import { getCategories } from '~/services/shop/operations';
import { hours, seconds } from '~/shared/utils/helpers';

export default function useCategories() {
    return useQuery<ShopTypes.CategoryQueryResult, HTTPError | Error>(
        ['categories'],
        () => getCategories(),
        {
            enabled: true,
            staleTime: hours(1),
            cacheTime: seconds(30),
            retry: 1,
        },
    );
}

export async function prefetchCategories({ queryClient }: Prefetch) {
    return queryClient.fetchQuery(['categories'], () => getCategories());
}
